import styled from 'styled-components';

export const Container = styled.div`
    display: flex;
    align-items: center;
    padding: 8px 12px;
    box-sizing: border-box;
    height: 40px;
    gap: 4px;
    background: #fff3e0;
    border: 1px solid #ef6c00;
    border-radius: 4px;
`;

export const ErrorLabel = styled.div`
    margin-left: 6px;
    height: 24px;
    font-family: Source Sans Pro, Helvetica, sans-serif;
    font-style: normal;
    font-weight: 400;
    font-size: 16px;
    line-height: 24px;
    color: #0b0c0c;
`;
